import { useCascadingMenu } from '../Root'
import type { ItemProps } from '../types'
import { useHandleItemKeyPress } from '../useHandleItemKeypress'
import * as styles from './styles'

type NoResultsItemProps = Pick<ItemProps, 'index' | 'label'>

export const NoResultsItem: React.FC<NoResultsItemProps> = ({
  index,
  label,
}) => {
  const { stackLevel } = useCascadingMenu()
  const { handleKeyPress, itemRef } = useHandleItemKeyPress({
    disabledKeys: ['Enter', ' ', 'ArrowRight'],
    hasChildren: false,
    index,
    onDescendMenu: null,
    onSelect: null,
  })

  return (
    <li
      id={styles.NO_RESULTS_ID}
      ref={itemRef}
      // Must be present, but undefined indicates that it is
      // not selectable
      aria-selected={undefined}
      aria-level={stackLevel}
      role="treeitem"
      tabIndex={-1}
      css={styles.item}
      onKeyDown={handleKeyPress}
    >
      {label}
    </li>
  )
}
NoResultsItem.displayName = 'Lapidary: CascadingMenu.NoResultsItem'
